import { FC, memo } from 'react';
import { Button, Tooltip } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import SiteMenu from '../SiteMenu/SiteMenu';
import Blocks from '../Blocks/Blocks';
import { OutgoingStatistics } from './OutgoingStatistics/OutgoingStatistics';
import { useOutgoingStatistics } from '../../hooks/components/useOutgoingStatistics/useOutgoingStatistics';
import { OutgoingStatisticsFilter } from './OutgoingStatistics/OutgoingStatisticsFilter/OutgoingStatisticsFilter';
import blockStyles from '../Blocks/style.module.css';
import { useStatisticsExport } from './shared/useStatisticsExport';
import { TaskCampaignFilter } from '../shared/TaskCampaignFilter';
import filterStyles from './OutgoingStatistics/OutgoingStatisticsFilter/style.module.css';

interface Props {
  selectedKey: string;
  onUpdateData: (key: string) => void;
  showIncoming: boolean;
}

export const StatisticsV2: FC<Props> = memo(
  ({ selectedKey, onUpdateData, showIncoming }: Props) => {
    const propsOutgoingStatistics = useOutgoingStatistics();
    const report = useStatisticsExport({
      direction: 'outbound',
      sections: propsOutgoingStatistics.dataSource,
      request: propsOutgoingStatistics.statisticsRequest,
      ready: propsOutgoingStatistics.canExportStatistics,
    });
    return (
      <>
        <Blocks
          topBlock={
            <div className={blockStyles.topBlockRow}>
              <SiteMenu
                title="Статистика исходящих заданий"
                svg={true}
                svgType="outgoingStats"
              />
              <Tooltip title="Сформировать отчет">
                <Button
                  type="primary"
                  aria-label="Сформировать отчет"
                  icon={<FileTextOutlined />}
                  loading={report.isReportLoading}
                  disabled={!report.canExport}
                  onClick={report.handleReport}
                />
              </Tooltip>
            </div>
          }
          middleBlock={
            <OutgoingStatisticsFilter
              clinics={propsOutgoingStatistics.clinics}
              onClinicsChange={propsOutgoingStatistics.onClinicsChange}
              onRangePickerChange={propsOutgoingStatistics.handleRangePicker}
              dateRange={propsOutgoingStatistics.dateRange}
              clinicValue={propsOutgoingStatistics.selectedClinics}
              filterOption={propsOutgoingStatistics.filterOption}
              onOpenClinics={propsOutgoingStatistics.handleOpenClinics}
              scenarioValue={propsOutgoingStatistics.selectedScenario}
              scenarioOptions={propsOutgoingStatistics.scenarioOptions}
              onScenarioChange={propsOutgoingStatistics.handleScenarioChange}
              campaignFilter={
                <TaskCampaignFilter
                  classNames={{
                    container: filterStyles.inputsContainer,
                    input: filterStyles.input,
                  }}
                  types={propsOutgoingStatistics.statisticsRequest.Types ?? []}
                  value={propsOutgoingStatistics.campaignFilters}
                  onChange={propsOutgoingStatistics.onCampaignFiltersChange}
                />
              }
              showTemplateFilter={propsOutgoingStatistics.showTemplateFilter}
              templates={propsOutgoingStatistics.templates}
              templateValue={propsOutgoingStatistics.selectedTemplates}
              onTemplatesChange={propsOutgoingStatistics.onTemplatesChange}
              onOpenTemplates={propsOutgoingStatistics.handleOpenTemplates}
            />
          }
          mainBlock={
            <OutgoingStatistics
              key="outgoing"
              dataSource={propsOutgoingStatistics.dataSource}
              loading={propsOutgoingStatistics.isLoading}
              sectionModes={report.sectionModes}
              onSectionModeChange={report.handleSectionModeChange}
            />
          }
        />
      </>
    );
  },
);

StatisticsV2.displayName = 'StatisticsV2';
